import { LayoutWithHeader } from "@/components/Layout";
import { Level } from "@/components/Level";
import { cn } from "@/libs";
import { ProgressBar } from "antd-mobile";
import styles from "./index.module.scss";
import { useSetup } from "./logic";

export const PageLevel = () => {
  const logic = useSetup();

  return (
    <LayoutWithHeader title={"信用等级"} back bg>
      <div className={styles.main}>
        <div className={styles.gradeArea}>
          <div className={styles.grades}>
            <Level level={logic.user.creditLevel} />
          </div>
          <ProgressBar
            className={styles.progressBar}
            percent={
              (logic.creditInfo.currentScore /
                logic.creditInfo.nextUpgradeScore) *
              100
            }
          />
          <div className={styles.subtitle}>
            <div className={styles.left}>{logic.creditInfo.currentScore}</div>
            <div className={styles.center}>
              距离升级还差{logic.creditInfo.diffScore}分
            </div>
            <div className={styles.right}>
              {logic.creditInfo.nextUpgradeScore}
            </div>
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles.title}>一、信用等级介绍</div>
          <div className={styles.content}>
            <p>1、信用等级划分</p>
            <p>
              1）VipPay信用等级体系包含五个大等级，每个大等级里分为五个等级，每个大等级分别显示不同的标志；具体如下图所示：
            </p>
            <div className={styles.grades}>
              <div className={styles.item}>
                <div
                  className={cn(
                    styles.grade,
                    "i-level__icon--1 i-level__icon--up"
                  )}
                ></div>
                <div>升级标准</div>
                <div>1分</div>
              </div>
              <div className={styles.item}>
                <div
                  className={cn(
                    styles.grade,
                    "i-level__icon--2 i-level__icon--up"
                  )}
                ></div>
                <div>升级标准</div>
                <div>10000分</div>
              </div>
              <div className={styles.item}>
                <div
                  className={cn(
                    styles.grade,
                    "i-level__icon--3 i-level__icon--up"
                  )}
                ></div>
                <div>升级标准</div>
                <div>60000分</div>
              </div>
              <div className={styles.item}>
                <div
                  className={cn(
                    styles.grade,
                    "i-level__icon--4 i-level__icon--up"
                  )}
                ></div>
                <div>升级标准</div>
                <div>160000分</div>
              </div>
              <div className={styles.item}>
                <div
                  className={cn(
                    styles.grade,
                    "i-level__icon--5 i-level__icon--up"
                  )}
                ></div>
                <div>升级标准</div>
                <div>310000分</div>
              </div>
            </div>
            <p>
              2）信用等级由信用等级分值决定，信用等级分值越高，信用等级越高，可享受的权益也就越多；
            </p>
            <p>
              3）信用等级分根据您在VipPay平台的个人账户的买卖V币情况，信誉记录，使用VipPay平台在合作三方充值提款金额、次数等情况，来综合计算得出的相应分值；
            </p>
            <p>2、各等级对应成长值</p>
            <p>
              信用等级分值决定信用等级，信用等级分值达到途中所示升级标准，即可升级为对应的等级。
            </p>
            <div className={styles.examples}>
              <div className={styles.group}>
                {logic.levelConfig.list.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className={cn(styles.row, {
                        [styles.rowDivide]: index >= 5 && index % 5 === 0,
                      })}
                    >
                      <div className={styles.label}>{item.label}</div>
                      <div className={styles.grades}>
                        <Level level={item.level + (index - (index % 5))} />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className={styles.title}>二、如何升级</div>
          <div className={styles.content}>
            <p>
              购买、出售：在VipPay平台进行购买以及出售V币行为，且保持良好的交易记录，即可获得信用积分；
            </p>
            <p>
              充值、提款：使用VipPay充值我们合作商户或从合作商户提款至VipPay钱包根据充提数值可获得相应信用积分。
            </p>
          </div>
          <div className={styles.title}>三、其他说明</div>
          <div className={styles.content}>
            <p>
              VipPay平台可在法律允许的范围内对规则进行变动调整，相关的变动和调整将公布在说明页面上，并与公布时即时生效。以上，最终解释权，归VipPay平台所有。
            </p>
          </div>
        </div>
      </div>
    </LayoutWithHeader>
  );
};
